import classNames from 'classnames';

import { cn } from '@/utils';

import * as styles from '../PostCommentsFeed.css';
import MarkDownRender from './MarkdownRender';
import { renderTime } from './renderTime';

interface Props {
  name: string;
  content: string;
  time: string;
  updatedTime?: string;
  isModerator: boolean;
  editedLabel?: string;
  authorLabel?: string;
}

const CommentDisplay = ({
  name,
  content,
  time,
  updatedTime,
  isModerator,
  editedLabel = 'edited',
  authorLabel = 'Author',
}: Props) => {
  const isEdited = updatedTime && updatedTime > time;

  return (
    <div className="flex flex-col items-start text-left">
      <div className="flex flex-col items-start">
        <p className={classNames(styles.commenterText, 'flex flex-row gap-x-2 items-center leading-5')}>
          <span className="flex flex-row gap-x-0.5 items-center">
            {name}
            {isModerator && <span className={cn(styles.authorBadge, 'ml-1')}>{authorLabel}</span>}
          </span>
          <span className={classNames(styles.timestampText, 'leading-4')}>
            {renderTime(time)}
            {isEdited && <span className="ml-1 opacity-70">({editedLabel})</span>}
          </span>
        </p>
      </div>
      <MarkDownRender className={classNames(styles.commentText)}>{content}</MarkDownRender>
    </div>
  );
};

export { CommentDisplay };
